export function normalizeTransactionType(type) {
  const value = String(type || "").toUpperCase();
  if (value === "DEBIT") return "EXPENSE";
  if (value === "CREDIT") return "INCOME";
  return value || "EXPENSE";
}

export function formatTransactionTypeLabel(type) {
  const normalized = normalizeTransactionType(type);
  if (normalized === "EXPENSE") return "Expense";
  if (normalized === "INCOME") return "Income";
  if (normalized === "TRANSFER") return "Transfer";
  return normalized;
}

export function formatCurrency(value) {
  const amount = Number(value || 0);
  return `₹ ${amount.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

export function formatAccountLabel(account) {
  const name = account?.accountName || "Account";
  const accountNumber = account?.accountNumber ? String(account.accountNumber) : "";
  const last4 = accountNumber ? accountNumber.slice(-4) : "";
  const numberLabel = last4 ? `****${last4}` : "";
  const balanceValue = account?.currentBalance;
  const balance =
    balanceValue !== null && balanceValue !== undefined && !Number.isNaN(Number(balanceValue))
      ? `₹${Number(balanceValue).toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`
      : "";
  return [name, numberLabel, balance].filter(Boolean).join(" • ");
}

export async function readErrorMessage(res, fallback) {
  if (!res) return fallback;
  try {
    const data = await res.clone().json();
    if (typeof data === "string" && data) return data;
    if (data?.message) return data.message;
    if (data?.error) return data.error;
  } catch {}
  try {
    const text = await res.text();
    if (text) return text;
  } catch {}
  return fallback;
}

export function toFormDate(value) {
  if (!value) return "";
  if (typeof value === "string") return value.slice(0, 10);
  try {
    return new Date(value).toISOString().slice(0, 10);
  } catch {
    return "";
  }
}

export function buildExpenseFormInitialValues(transaction) {
  return {
    accountId: transaction?.accountId || "",
    categoryId: transaction?.categoryId || "",
    merchantId: transaction?.merchantId || "",
    amount: transaction?.transactionAmount ?? transaction?.amount ?? "",
    date: toFormDate(transaction?.transactionDate ?? transaction?.date),
    description: transaction?.description || "",
    tags: Array.isArray(transaction?.tags) ? transaction.tags : [],
  };
}

export function buildIncomeFormInitialValues(transaction) {
  return {
    accountId: transaction?.accountId || "",
    categoryId: transaction?.categoryId || "",
    amount: transaction?.transactionAmount ?? transaction?.amount ?? "",
    date: toFormDate(transaction?.transactionDate ?? transaction?.date),
    description: transaction?.description || "",
    tags: Array.isArray(transaction?.tags) ? transaction.tags : [],
  };
}

export function buildTransferFormInitialValues(transaction) {
  return {
    fromAccountId: transaction?.fromAccountId || "",
    toAccountId: transaction?.toAccountId || "",
    amount: transaction?.transactionAmount ?? transaction?.amount ?? "",
    date: toFormDate(transaction?.transactionDate ?? transaction?.date),
    description: transaction?.description || "",
  };
}

export function monthKey(dateValue) {
  const date = dateValue ? new Date(dateValue) : new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  return `${year}-${month}`;
}

export function monthLabel(key) {
  const [year, month] = String(key || "").split("-");
  if (!year || !month) return key;
  const date = new Date(Number(year), Number(month) - 1, 1);
  return date.toLocaleDateString(undefined, { month: "long", year: "numeric" });
}

export function recentMonthOptions(count = 8) {
  const now = new Date();
  return Array.from({ length: count }, (_, index) => {
    const date = new Date(now.getFullYear(), now.getMonth() - index, 1);
    const value = monthKey(date);
    return { value, label: monthLabel(value) };
  });
}

export function transactionMonth(transaction) {
  return monthKey(transaction?.transactionDate);
}
